import { Pipe, PipeTransform, inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { TaxRateDisplay } from '@models/index';

@Pipe({ name: 'taxRate' })
export class TaxRatePipe implements PipeTransform {
    private readonly translateService = inject(TranslateService);

    transform(tax: TaxRateDisplay): string {
        if (!tax) {
            return '';
        }

        if (!tax.isIncludeInPVP) {
            return `${tax.rate}%`;
        }

        const includedSuffix = this.translateService.instant('tax_rate_included_suffix');
        return `${tax.rate}% ${includedSuffix}`;
    }
}
